enum CarLoanTypeEnum
{
    SMALL_CARS = "SMALL_CARS",
    LARGE_CARS = "LARGE_CARS",
}

export default CarLoanTypeEnum;
